
import { ReactNode } from 'react';
import classnames from 'classnames';

import Spinner, { Colors, Positions } from 'components/layout/Spinner';

import StyledComponent from './styles';


export interface SpinnerBlockProps {
    loading: boolean,
    children: ReactNode
}

const SpinnerBlock = (props: SpinnerBlockProps) => {
    const { loading = false, children } = props;

    return (
        <StyledComponent>
            <div className='spinner-block'>
                <div className={classnames('spinner-block__inner', { 'spinner-block__inner--loading': loading })} ></div>
                {loading && (
                    <div className='spinner-block__spinner'>
                        <Spinner position={Positions.Relative} />
                    </div>
                )}
                {children}

            </div>
        </StyledComponent>
    );
};

export default SpinnerBlock;